import styled from 'styled-components'
import { Button } from 'shared/components/buttons'
import { openPopup } from 'shared/util/gif-social'
import { gridSpacing } from 'shared/css/grid.css'
import colors from 'shared/css/colors.css'

const SOCIAL = ['facebook', 'pinterest', 'tumblr', 'reddit']
const SOCIAL_URLS = {
    facebook: 'http://www.facebook.com/sharer/sharer.php?u=',
    tumblr: 'http://www.tumblr.com/widgets/share/tool?canonicalUrl=',
    pinterest: 'http://www.pinterest.com/pin/create/link/?url=',
    reddit: 'http://www.reddit.com/submit?url=',
}

const Container = styled.div`
    display: flex;
    width: 100%;
`

const SocialButton = styled(Button)`
    margin-right: ${gridSpacing};
    width: 100%;

    &:before {
        font-size: inherit;
        margin: 0;
    }

    &:last-child {
        margin: 0;
    }
`

const StoryShare = ({ url }) => (
    <Container>
        {SOCIAL.map((type) => (
            <SocialButton
                key={type}
                color={colors[`${type}Color`]}
                className={`ss-icon ss-social ss-${type}`}
                href={SOCIAL_URLS[type] + url}
                onClick={(e) => {
                    e.preventDefault()
                    openPopup(SOCIAL_URLS[type] + url, type)
                }}
            />
        ))}
    </Container>
)

export default StoryShare
